/* unplugin-vue-components disabled */import { render } from "./contact-tile.vue?vue&type=template&id=00217016&scoped=true"
import script from "./contact-tile.vue?vue&type=script&lang=js"
export * from "./contact-tile.vue?vue&type=script&lang=js"

import "./contact-tile.vue?vue&type=style&index=0&id=00217016&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00217016"],['__file',"src/pages/pulse/contact-tile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00217016"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00217016', __exports__)) {
    api.reload('00217016', __exports__)
  }
  
  module.hot.accept("./contact-tile.vue?vue&type=template&id=00217016&scoped=true", () => {
    api.rerender('00217016', render)
  })

}


export default __exports__